import { FETCH_OFFERS, TOGGLE_BUY_NOW_FILTER } from 'dealer-reducers'
import { FETCH_OFFERS as FETCH_PAGINATED_OFFERS } from '../../redux/paginatedOffersReducer'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'
import HomePageAds from '../molecules/HomePageAds'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Space from '../atoms/Space'
import Button from '../atoms/Button'
import View from '../atoms/View'
import MotoSvg from '../other/svg/MotoSvg'
import BuyNowSvg from '../other/svg/BuyNowSvg'
import Text from '../atoms/TextNew'
import Layout from '../layout/Layout'
import track from 'src/helpers/track'

interface Props {
  estibrand: 'estimoto' | 'esticampo' | 'estiagro'
}
const Home = ({ estibrand }: Props): JSX.Element => {
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/browsing/browse')
    // dispatch(FETCH_HOME_SCREEN_OFFERS())
  }, [dispatch, navigate])

  const { motorbike_offers, camper_offers, agricultural_offers } = useSelector(
    (state: RootReducer) => state.homeScreenOffersReducer
  )

  const offersByEstibrand = {
    estimoto: motorbike_offers,
    estiagro: agricultural_offers,
    esticampo: camper_offers
  }

  return (
    <Layout withoutToolbar>
      <>
        <HomePageAds offers={offersByEstibrand[estibrand]} estibrand={estibrand} />
        <Space y={6} />
        <View className="flex justify-between w-full gap-4 text-white">
          <Button
            onClick={() => {
              navigate('/archived-on-platform')
            }}
            color="motoOrange"
            customStyles="flex justify-center gap-3 ml-3 px-0 w-[336px] px-4"
            iconComponent={<MotoSvg className="w-12" />}>
            <Text className="text-white text-xl font-SemiBold">{t('just_sold')}</Text>
          </Button>
          <Button
            iconComponent={<BuyNowSvg className="w-12" />}
            color="groupBlue"
            onClick={() => {
              dispatch(TOGGLE_BUY_NOW_FILTER({ tab: currentTab }))
              track('dealer_buy_now_toggle')
              dispatch(FETCH_OFFERS({ tab: 'browse', refetch: true }))
              dispatch(FETCH_PAGINATED_OFFERS())
              navigate('/browsing/browse')
            }}
            customStyles="flex justify-center gap-3 mr-3 px-0 w-[336px] px-4">
            <View>
              <Text className="text-white text-l text-center">{t('only_buy_now_dec')}</Text>
              <Text className="text-white text-xl font-Bold text-center">{t('only_buy_now')}</Text>
            </View>
          </Button>
        </View>
        <Link to="/archived-on-platform"></Link>
      </>
    </Layout>
  )
}
export default Home
